import { Skeleton } from '@mokoboko/components';

export const CreditSummaryCardSkeleton = () => {
  return (
    <div className="flex flex-col rounded-xl bg-white px-5 py-4 shadow-skeu-secondary sm:px-4">
      <div className="flex items-center gap-4">
        <Skeleton
          isRounded
          className="order-last !h-14 w-14 shrink-0 sm:order-first"
        />

        <div className="flex min-w-0 flex-1 flex-col gap-1.5">
          <Skeleton text="body-lg" width={176} />
          <Skeleton text="body-sm" width={224} />
        </div>

        <Skeleton height={24} width={72} className="hidden shrink-0 sm:block" />
      </div>
    </div>
  );
};
